import {
  USEDCAR_LANDING_TRACKING_CATEGORY,
  CLICKED_PRICE_ACTION,
  BUDGET_RANGE_LIMITS,
  CLICKED_POPULAR_BRAND,
} from "../constants";
import { getUsedCarSearchPagePath } from "GlobalUtils/UrlFactory";
import { getUsedCarBudgetUrls } from "SrcPath/utils/UrlFactory";
import { RUPEE_SYMBOL } from "GlobalConstant/index";
import { BODY_TYPE, FUEL_TYPE } from "SrcPath/NewCars/constants/NewCars";
import { fireInteractiveTracking } from "GlobalUtils/Analytics";
import { trackCustomData } from "GlobalUtils/cwTrackingPwa";

/**
 * find recent cats and map them according to Usedlanding store recentCars state
 * @param {Array<object>} list - list of recent cars
 * @returns{Array<object>} - list of recent cars mapped according to Usedlanding store recentCars state
 */
export const formatRecentCarsResponse = recentCars => {
  if (!recentCars) {
    return null;
  }
  return recentCars.map(car => {
    return {
      carName: car.carName,
      url: car.url,
      price: RUPEE_SYMBOL + " " + car.price,
      makeYear: car.makeYear,
      mainImageurl: car.imageUrl,
      km: car.km,
      fuel: car.fuel,
      profileId: car.profileId,
    };
  });
};

/**
 * @param {number} index - order of the card clicked
 * @param {string} cityName - cityname of the stock
 * @returns {object} - tracking object for recent cars card click
 */
export const getCarsCarousalTrackingObject = (
  cityName,
  categoryName,
  trackingAction
) => {
  return {
    bhriguCat: categoryName,
    gaCat: categoryName,
    gaActClick: trackingAction,
    gaLblClick: `cityName=${cityName}`,
    bhriguActClick: trackingAction,
    bhriguLblClick: `cityName=${cityName}`,
    trackClick: true,
  };
};

export const getViewAllCarsLink = (cityMaskingName, price) => {
  const priceString = price ? `&price=${price}` : "";
  return `${getUsedCarSearchPagePath({
    cityMaskingName,
  })}?so=1&sc=6${priceString}`;
};

export const getBudgetTabTrackingObject = label => {
  return {
    bhriguCat: USEDCAR_LANDING_TRACKING_CATEGORY,
    gaCat: USEDCAR_LANDING_TRACKING_CATEGORY,
    gaActClick: CLICKED_PRICE_ACTION,
    gaLblClick: label,
    bhriguActClick: CLICKED_PRICE_ACTION,
    bhriguLblClick: label,
    trackClick: true,
  };
};

/**
 * get the cityMasking name and return the array of object having id, link and text for budget filter.
 * @param {string} cityMaskingName
 * @returns {Array<object>} - list having id, link and text for budget based url.
 */
export const getBudgetList = ({ cityMaskingName }) => {
  return [
    {
      id: 3,
      href: getUsedCarBudgetUrls({
        minPrice: 0,
        maxPrice: 200000,
        cityMaskingName: cityMaskingName,
      }),
      text: `Under ${RUPEE_SYMBOL} 2 Lakh`,
    },
    {
      id: 4,
      href: getUsedCarBudgetUrls({
        minPrice: 200000,
        maxPrice: 400000,
        cityMaskingName: cityMaskingName,
      }),
      text: `${RUPEE_SYMBOL} 2 - 4 Lakh`,
    },
    {
      id: 5,
      href: getUsedCarBudgetUrls({
        minPrice: 400000,
        maxPrice: 700000,
        cityMaskingName: cityMaskingName,
      }),
      text: `${RUPEE_SYMBOL} 4 - 7 Lakh`,
    },
    {
      id: 6,
      href: getUsedCarBudgetUrls({
        minPrice: 700000,
        maxPrice: 1000000,
        cityMaskingName: cityMaskingName,
      }),
      text: `${RUPEE_SYMBOL} 7 - 10 Lakh`,
    },
    {
      id: 7,
      href: getUsedCarBudgetUrls({
        minPrice: 1000000,
        maxPrice: 1500000,
        cityMaskingName: cityMaskingName,
      }),
      text: `${RUPEE_SYMBOL} 10 - 15 Lakh`,
    },
    {
      id: 8,
      href: getUsedCarBudgetUrls({
        minPrice: 1500000,
        maxPrice: 2000000,
        cityMaskingName: cityMaskingName,
      }),
      text: `${RUPEE_SYMBOL} 15 - 20 Lakh`,
    },
    {
      id: 9,
      href: getUsedCarBudgetUrls({
        minPrice: 2000000,
        maxPrice: undefined,
        cityMaskingName: cityMaskingName,
      }),
      text: "Luxury Cars",
    },
  ];
};

export const getLowerBudgetValue = lowerBudgetLimit => {
  return lowerBudgetLimit ? Number(lowerBudgetLimit) : BUDGET_RANGE_LIMITS.min;
};

export const getUpperBudgetValue = upperBudgetLimit => {
  return upperBudgetLimit ? Number(upperBudgetLimit) : BUDGET_RANGE_LIMITS.min;
};

/**
 *@returns {Array<object>} - array of used car body types.
 */
export const getBodyTypeData = () => {
  return BODY_TYPE.map(element => {
    return {
      id: element.id,
      name: element.name,
      icon: element.icon,
      href: getUsedCarSearchPagePath({ bodyTypeId: element.id }),
      shrink: element.shrink,
    };
  });
};

/**
 * @returns {Array<object>} - array of used car fuel types.
 */
export const getFuelTypeData = () => {
  return FUEL_TYPE.map(element => {
    return {
      id: element.id,
      name: element.name,
      icon: element.icon,
      href: getUsedCarSearchPagePath({ fuelTypeId: element.id }),
    };
  });
};

export const getUsedMakeSearchPagePath = makeEvent => {
  if (!makeEvent) {
    return null;
  }
  return getUsedCarSearchPagePath({
    makeMaskingName: makeEvent.makeMaskingName,
    cityMaskingName: makeEvent.cityMaskingName,
  });
};
const getPopularBrandLabel = make => {
  return `brand=${make.makeName}|city=${
    make.cityMaskingName ? make.cityMaskingName : "India"
  }`;
};

export const trackPopularBrandLogoClick = make => {
  fireInteractiveTracking(
    USEDCAR_LANDING_TRACKING_CATEGORY,
    CLICKED_POPULAR_BRAND,
    getPopularBrandLabel(make)
  );
  trackCustomData(
    USEDCAR_LANDING_TRACKING_CATEGORY,
    CLICKED_POPULAR_BRAND,
    getPopularBrandLabel(make),
    false
  );
};
